import UnifiedPhaseNode from './UnifiedPhaseNode';
import ToolNode from './ToolNode';
import ArtifactNode from './ArtifactNode';
import PersonaNode from './PersonaNode';

export const workflowNodeTypes = {
  phase: UnifiedPhaseNode,
  tool: ToolNode,
  persona: PersonaNode,
  artifact: ArtifactNode
};
